import { inject, Injectable, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap, finalize, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Usuario, ProfileResponse } from '../models/usuario.models';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private readonly http = inject(HttpClient);
  private readonly userSignal = signal<Usuario | null>(null);
  private profileRequest$: Observable<ProfileResponse> | null = null;

  readonly currentUser = computed(() => this.userSignal());
  readonly loaded = computed(() => !!this.userSignal());

  getProfile(): Observable<ProfileResponse> {
    if (this.profileRequest$) {
      return this.profileRequest$;
    }

    this.profileRequest$ = this.http.get<ProfileResponse>(`${environment.apiUrl}/perfil`).pipe(
      tap((response) => {
        this.userSignal.set(response.data);
      }),
      finalize(() => {
        this.profileRequest$ = null;
      }),
      shareReplay(1)
    );

    return this.profileRequest$;
  }

  clearProfile(): void {
    this.userSignal.set(null);
  }
}
